import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { octoberGalleryMedia } from "../../data/octoberGalleryMedia";
import { clientGalleryFollowupMedia } from "../../data/clientGalleryFollowupMedia";
import { firm } from "../../data/site";
import { SiteLink } from "../SiteLink";
const cards = [{
  id: "bystander-training",
  title: "Bystander assistance training",
  copy: "Learn about motorcycle crash-response classes for riders and bystanders, supported by the firm.",
  label: "Explore training and classes",
  path: "/accident-scene-management-training-michigan/",
  image: clientGalleryFollowupMedia.crashQuestions
}, {
  id: "free-resources",
  title: "FREE resources for Michigan riders",
  copy: "Understand motorcycle insurance, no-fault benefits and injury claims with the firm’s practical guides.",
  label: "Explore the insurance guide",
  path: "/michigan-motorcycle-law-insurance-guide/",
  image: clientGalleryFollowupMedia.freeResources
}, {
  id: "community",
  title: "Giving back to the motorcycle community",
  copy: "A portion of the firm’s legal fees supports motorcycle awareness, bystander assistance and rider education programs.",
  label: "See how the firm gives back",
  path: "/helping-the-biker-community/",
  image: octoberGalleryMedia.awareness
}, {
  id: "riding-events",
  title: "Michigan motorcycle events",
  copy: "Find rides, rallies and bike nights across Michigan. Explore the event calendar and photos from the riding community.",
  label: "Explore events and photos",
  path: "/events/",
  image: clientGalleryFollowupMedia.events
}, {
  id: "meet-team",
  title: "Meet the team",
  copy: `Meet the attorneys who work with ${firm.displayName} to represent injured riders and their families.`,
  label: "Get to know the legal team",
  path: "/about-us/",
  image: clientGalleryFollowupMedia.team
}, {
  id: "client-testimonials",
  title: "Client testimonials",
  copy: "Read what clients say about their experience with the firm.",
  label: "Read client testimonials",
  path: "/law-firm-testimonials/",
  image: clientGalleryFollowupMedia.testimonials
}];
export function ResourceGallery() {
  return <section aria-labelledby="resource-gallery-title" className="resource-gallery" data-id="element-268" data-mp="1brug16db17et">
    <div className="page-container resource-gallery-inner" data-id="element-269" data-mp="1pr3x089c45ju">
      <p className="eyebrow text-crimson" data-id="element-270" data-mp="1psnbpufce8ji">For the road ahead</p>
      <h2 id="resource-gallery-title" className="section-title" data-id="element-271" data-mp="1lp8vb2nhrq5j">Resources, people and community.</h2>
      <div className="image-resource-grid" data-id="element-272" data-mp="1zohy90mosnrk">
        {cards.map(card => <SiteLink key={card.id} path={card.path} className="image-resource-card" data-id="element-273" data-mp="1zmx8dobbht01">
          <div className="image-resource-photo" data-id="element-274" data-mp="1uo2pkmdco4fx"><img src={card.image.src} srcSet={card.image.srcSet} sizes="(min-width:1101px) 464px, (min-width:640px) 50vw, 100vw" width={card.image.width} height={card.image.height} alt="" loading="lazy" decoding="async" data-id="element-275" data-mp="29fl044nfx6rw" /></div>
          <div className="image-resource-copy" id={card.id} data-id="element-276" data-mp="2igsvaduntrhr">
            <h3 data-id="element-277" data-mp="2dgy74i29rg0e">{card.title}</h3>
            <p data-id="element-278" data-mp="2dhpqmuildnab">{card.copy}</p>
            <span className="image-resource-link" data-id="element-279" data-mp="2dihns9ru7t2p">{card.label} <ArrowRightIcon size={21} aria-hidden="true" data-id="element-280" data-mp="2x1yhmxyjy9ql" /></span>
          </div>
        </SiteLink>)}
      </div>
    </div>
  </section>;
}